import EliminarCliente from './EliminarCliente'

export default EliminarCliente
